import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import getServiceItemIds from 'owa-mail-store/lib/services/utils/getServiceItemIds';
import copyItemRequest from 'owa-service/lib/factory/copyItemRequest';
import copyItemOperation from 'owa-service/lib/operation/copyItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * The service command to copy items to a specified destination folder
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return a Promise which contains the CopyItemResponse
 */
export default function copyItemsService(itemIds, destinationFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return copyItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
/**
 * Configure the CopyItemRequest body
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return the CopyItemRequest body
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return copyItemRequest({
        ToFolderId: getServiceContextFolderId(destinationFolderId),
        ItemIds: getServiceItemIds(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=copyItemsService.js.map